module.exports = __webpack_public_path__ + "static/media/FC-Hockey-Logo-White.993004e7.svg";